// Printf for JS
String.prototype.printf = function(){
    var formatted = this;
    for( var arg in arguments ) {
        var before_formatted = formatted.substring(0, formatted.indexOf("%s", 0));
        var after_formatted  = formatted.substring(formatted.indexOf("%s", 0)+2, formatted.length);
        formatted = before_formatted + arguments[arg] + after_formatted;
    }
    return formatted;
};

// Switching tabs
function spbc_switchTab(tab, params){

	var tab_name = tab.classList[1].replace('spbc_tab_nav-', '')
	jQuery('.spbc_tab_nav').removeClass('spbc_tab_nav--active');
	jQuery('.spbc_tab').removeClass('spbc_tab--active');
	jQuery(tab).addClass('spbc_tab_nav--active');
	jQuery('.spbc_tab-'+tab_name).addClass('spbc_tab--active');

	if(!jQuery(tab).data('loaded')){
		var data = {
			action: 'spbc_settings__draw_elements',
			tab_name: tab_name,
			security: spbcSettings.ajax_nonce
		};
		var params = {
			callback: spbc_draw_settings_callback,
			notJson: true,
            additional: params || null,
		};
		spbc_sendAJAXRequest( data, params, tab );
	}else if(params && params.action){
        switch (params.action){
            case 'highlight':
                spbcHighlightElement(params.target, params.times);
                break;
            case 'click':
                setTimeout(function(){
                    jQuery('#'+params.additional.target).click();
                }, 500);
                break;
        }
	}
}

function spbc_draw_settings_callback(result, data, params, obj){

	jQuery(obj).data('loaded', true);
	jQuery('.spbc_tab-'+data.tab_name).replaceWith(result);
	var tab = jQuery('.spbc_tab-'+data.tab_name);
	tab.addClass('spbc_tab--active');

	if(params.additional){
	    switch (params.additional.action) {
            case 'highlight':
		        spbcHighlightElement(params.additional.target, params.additional.times);
                break;
            case 'click':
                setTimeout(function(){
		            jQuery('#'+params.additional.target).click();
		            console.log('some');
                }, 500);
                break;
        }
    }

	jQuery(tab).on('click', '.spbc_hint-send_'+data.tab_name, function(){
			jQuery('.spbc_hint-send_'+data.tab_name).hide();
		spbc_sendAJAXRequest(
			{action: 'spbc_send_'+data.tab_name, tab_name: data.tab_name},
			{callback: spbc_send_logs_callback}
		);
	});
}

function spbc_send_logs_callback(result, data, params, obj){
	jQuery('.spbc_tab_nav-'+data.tab_name).data('loaded', false);
	spbc_switchTab(document.getElementsByClassName('spbc_tab_nav-'+data.tab_name)[0]);
}

// Settings dependences
function spbcSettingsDependencies(settingsIDs, enable){

	if(typeof settingsIDs === 'string'){
		tmp = [];
		tmp.push(settingsIDs);
		settingsIDs = tmp;
	}

	enable = typeof enable === 'undefined' ? null : +enable;

	settingsIDs.forEach(function(settingID, i, arr){

		var elem = document.getElementById('spbc_setting_'+settingID),
            do_disable = function(){elem.setAttribute('disabled', 'disabled');},
            do_enable  = function(){elem.removeAttribute('disabled');};

        if(enable !== null) // Set
            enable === 1 ? do_enable() : do_disable();
        else // Switch
            elem.getAttribute('disabled') === null ? do_enable() : do_disable();

	});
}

function spbc_settings__show_description(label, setting_id){
	
//	!jQuery(e.target).hasClass('spbc_long_description__show')
	
	var remove_desc_func = function(e){
		if(typeof e === 'undefined' || ((jQuery(e.target).parent('.spbc_long_desc').length == 0 || jQuery(e.target).hasClass('spbc_long_desc__cancel')) && !jQuery(e.target).hasClass('spbc_long_description__show'))){
			jQuery('.spbc_long_desc').remove();
			jQuery(document).off('click', remove_desc_func);
		}
	};
	
	remove_desc_func();
	
	label.after("<div id='spbc_long_desc__"+setting_id+"' class='spbc_long_desc'></div>");
	var obj = jQuery('#spbc_long_desc__'+setting_id);
	obj.append("<i class='icon-spin1 animate-spin'></i>")
		.append("<div class='spbc_long_desc__angle'></div>")
		.css({
			top: label.position().top - 5,
			left: label.position().left + 25
		});
	
	
	spbc_sendAJAXRequest(
		{action: 'spbc_settings__get_description', setting_id: setting_id},
		{
			spinner: obj.children('img'),
			callback: function(result, data, params, obj){
								
				obj.empty()
					.append("<div class='spbc_long_desc__angle'></div>")
					.append("<i class='spbc_long_desc__cancel icon-cancel'></i>")
					.append("<h3 class='spbc_long_desc__title'>"+result.title+"</h3>")
					.append("<p>"+result.desc+"</p>");
				
				jQuery(document).on('click', remove_desc_func);
			}
		},
		obj
	);
}

// Shows/hides full text
function spbcStartShowHide(){
	jQuery('.spbcShortText').on('mouseover', function(){ jQuery(this).hide(); jQuery(this).next().show(); });
	jQuery('.spbcFullText').on('mouseout',   function(){ jQuery(this).hide(); jQuery(this).prev().show(); });
}

jQuery(document).ready(function(){
	
	jQuery('#spbc_gdpr_open_modal').on('click', function(){
		jQuery('#gdpr_dialog').dialog({
			modal:true, 
			show: true,
			position: { my: "center", at: "center", of: window },
			width: +(jQuery('#wpbody').width() / 100 * 70), // 70% of #wpbody
			height: 'auto',
			title: 'GDPR compliance',
			draggable: false,
			resizable: false,
			closeText: "Close",
		});
	});
	
	
	//* TAB_CONROL
	
		jQuery('.spbc_tab_nav-summary').data('loaded', true); // Summary tab loaded by default
		jQuery('.spbc_tabs_nav_wrapper').on('click', '.spbc_tab_nav', function(event){
			spbc_switchTab(event.currentTarget);
		});
		
		// Get additional params
        var params = {
            target: location.search.match(/spbc_target=(\S*?)(&|$)/) ? location.search.match(/spbc_target=(\S*?)(&|$)/)[1] : null,
            action: location.search.match(/spbc_action=(\S*?)(&|$)/) ? location.search.match(/spbc_action=(\S*?)(&|$)/)[1] : null,
            times: location.search.match(/spbc_times=(\S*?)(&|$)/)   ? location.search.match(/spbc_times=(\S*?)(&|$)/)[1]  : 3,
        };
        // Legacy support
        params.target = location.search.match(/spbc_highlight=(\S*?)(&|$)/) ? location.search.match(/spbc_highlight=(\S*?)(&|$)/)[1] : params.target;
        params.action = location.search.search(/spbc_highlight=(\S*?)(&|$)/) != -1
            ? 'highlight'
            : params.action;

		// Get open tab form query
		var spbc_tab = document.getElementsByClassName('spbc_tab_nav-' + (location.search.match(/spbc_tab=(\S*?)(&|$)/) ? location.search.match(/spbc_tab=(\S*?)(&|$)/)[1] : ''))[0] || null;

		// TAB SWITCHING
		// Switch by URL
		if(spbc_tab){

		// Switch to DEBUG
		}else if( +spbcSettings.debug ){
			spbc_tab = document.getElementsByClassName('spbc_tab_nav-debug')[0];
		// Switch by DEFAULT
		}else if( +spbcSettings.wpms && !+spbcSettings.is_main_site){
			spbc_tab = document.getElementsByClassName('spbc_tab_nav-security_log')[0];
		// Switch if KEY IS BAD
		}else if( +spbcSettings.key_is_ok ){
			// spbc_tab = document.getElementsByClassName('spbc_tab_nav-summary')[0];
			spbc_tab = document.getElementsByClassName('spbc_tab_nav-scanner')[0]; 
		// Switch if KEY IS BAD
		}else{
			spbc_tab = document.getElementsByClassName('spbc_tab_nav-settings_general')[0];
			params = {
			    target: 'spbc_key',
                action: 'highlight',
                times: 3,
            };
		}
		
		// Switch tab
		if(spbc_tab) spbc_switchTab(spbc_tab, params);
		
	//*/ TAB_CONROL END
});